<form [formGroup]="form" (ngSubmit)="showModal.set(true)" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <div class="mt-6 mb-3">
        <h1 class="text-primary">Ahora vamos a conocernos...</h1>
    </div>

    <app-input class="w-full"
        [config]="dataInputs()[0]"
        (submitValue)="handleValue($event)"
    ></app-input>

    <app-selected class="w-full"
        [config]="dataSelected().at(0)"
        (selectValue)="handleSelect($event)"
    ></app-selected>

    @for (config of dataInputs().slice(1); track $index) {
        <app-input
            class="w-full"
            [config]="config"
            (submitValue)="handleValue($event)"
        ></app-input>
    }

    @if (form.get('identificationType')?.value != '1' && form.get('identificationType')?.value !== null) {
        <app-selected class="w-full"
            [config]="dataSelected().at(1)"
            (selectValue)="handleSelect($event)"
        ></app-selected>
    }

    <app-birthdate class="w-full"
        [config]="birthdateConfig()"
        (submit)="handleBirthdate($event)">
    </app-birthdate>

    <div class="mb-3">
        <input
        [ngClass]="{
            'is-invalid':
            (form.get('authorization')?.touched) &&
            form.get('authorization')?.invalid
        }"
        formControlName="authorization"
        type="checkbox"
        class="form-check-input"
        id="terms"
        />
        <label class="text-[11px] text-gray-700" for="terms">
        He leído y acepto los <a class="underline text-blue" (click)="showTerms.set(true);">términos y condiciones</a> y acepto que el tratamiento de mis datos personales se realice de acuerdo con la <a class="underline text-blue" href="https://www.fincomercio.com/corporativo/politica-general-de-proteccion-de-datos-personales" target="_blank">política de privacidad</a>
        </label>
    </div>


    <button class="btn-primary mb-6" [disabled]="!form.valid || disabledButton">
        Continuar
    </button>


</form>


<!-- Modals -->

@if (showModal()) {
    <app-modal (close)="showModal.set(false)">
        <!-- confirmation-flow.component.html -->
        <div class="space-y-6">
        <!-- Indicador de pasos -->
        <div class="flex items-center justify-center space-x-4">
            <div class="flex flex-col items-center">
            <div [class]="currentStep === 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'" 
                class="w-8 h-8 rounded-full flex items-center justify-center">
                1
            </div>
            <span class="text-xs mt-1" [class.font-medium]="currentStep === 1">Datos</span>
            </div>
            <div class="h-0.5 w-8 bg-gray-300"></div>
            <div class="flex flex-col items-center">
            <div [class]="currentStep === 2 ? 'bg-blue-500 text-white' : 'bg-gray-200'" 
                class="w-8 h-8 rounded-full flex items-center justify-center">
                2
            </div>
            <span class="text-xs mt-1" [class.font-medium]="currentStep === 2">Info</span>
            </div>
        </div>

        <!-- Paso 1: Confirmación de datos -->
        @if (currentStep === 1) {
        <div class="space-y-4">
            <h2 class="text-xl font-bold text-center">Confirma tus datos</h2>
  
            <!-- Contenedor de datos existentes -->
            <div class="space-y-4 bg-gray-50 p-4 rounded-lg">
                <!-- Documento -->
                <div>
                <h3 class="text-sm font-medium text-gray-500">Número de documento</h3>
                <p class="mt-1 text-gray-900">{{ form.get('identification')?.value || 'No Proporcionado' }}</p>
                </div>
                
                <!-- Celular -->
                <div>
                <h3 class="text-sm font-medium text-gray-500">Número de celular</h3>
                <p class="mt-1 text-gray-900">{{ form.get('phone')?.value || 'No proporcionado'}}</p>
                </div>
                
                <!-- Email -->
                <div>
                <h3 class="text-sm font-medium text-gray-500">Correo electrónico</h3>
                <p class="mt-1 text-gray-900">{{ form.get('email')?.value || 'No proporcionado'}}</p>
                </div>
            </div>
            
            <div class="text-sm text-gray-500 text-center">
                <p>Por favor verifica que esta información sea correcta antes de continuar.</p>
            </div>
            
            <div class="flex flex-col space-y-4">
                <button (click)="proceedToNextStep()" 
                        class="flex-1 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                Confirmar y continuar
                </button>

                <button (click)="showModal.set(false)" 
                        class="flex-1 px-4 py-2 btn-secundary">
                Editar información
                </button>
            </div>
        </div>
            }

        <!-- Paso 2: Autorización de cámara -->
         @if (currentStep === 2) {
            
        <div class="space-y-6 text-center">
            <h2 class="text-xl font-bold">Validación de identidad</h2>
            
            <div class="p-4 bg-blue-50 rounded-lg">
            <p class="text-gray-700">
                Necesitaremos acceso a tu cámara para validar tu identidad. 
                Por favor, autorízalo cuando se solicite. ¡Gracias!
            </p>
            </div>
            
            <div class="flex justify-center">
            <button (click)="proceedToNextStep()" 
                    class="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                Continuar con la validación
            </button>
            </div>
        </div>
         }
        </div>
    </app-modal>
}

@if(showTerms()){
    <app-modal (close)="showTerms.set(false)">
        <h2 class="text-xl text-secundary font-bold mb-4 text-center">
            Terminos y condiciones Fincomercio
        </h2>
        <p class="text-sub-label text-justify">
            CALIDAD DE ASOCIADO / DEBERES, OBLIGACIONES Y AUTORIZACIONES Con mi firma
            en este documento ACEPTO la calidad de asociado a FINCOMERCIO con los
            deberes y derechos contemplados en la ley 79 de 1988, art. 23 y 24 y los
            art. 16 y 17 de los Estatutos de la Cooperativa respecto de los cuales
            puedo acceder en cualquier momento a través de la página web
            www.fincomercio.com, así mismo ACEPTO que el valor mensual de mi cuota de
            Aporte Social se estipulará de acuerdo con mi salario que devengue o de
            acuerdo a lo establecido con el pagador pensional y está sujeta al ajuste
            de incremento anual determinado por la Cooperativa. AUTORIZO desde ahora a
            FINCOMERCIO para que incremente de forma automática y anualmente el valor
            de mi cuota de Plan de Ahorro Programado (PAP) de acuerdo con las
            políticas de incremento de cuota vigentes. AUTORIZO a la Cooperativa de
            Ahorro y Crédito FINCOMERCIO para que me represente en mi calidad de
            cedente o cesionario en los negocios jurídicos de cesión de aportes, e
            instrumentalice dicho proceso. ORIGEN DE FONDOS Declaro que los recursos
            depositados, obtenidos y/o involucrados en las operaciones financieras con
            FINCOMERCIO, tienen origen y destino lícito en las actividades de igual
            tipo que constituyen el giro normal de mis negocios, tal como se describen
            en esta solicitud y que no se relacionan con actividades ilícitas o
            delictivas, especialmente lavado de activos y/o financiación al
            terrorismo. Que conozco y aplico las normas de prevención de lavado de
            activos y financiación al terrorismo y no permitiré que terceros realicen
            transacciones de ninguna naturaleza en mis productos o entreguen en mi
            nombre o de la entidad que represento fondos, bienes y/o servicios
            relacionados con actividades ilícitas o a favor de personas involucradas
            con las mismas. Autorizo a FINCOMERCIO para terminar unilateralmente
            cualquier relación contractual o exigir en forma anticipada el pago de
            cualquier obligación en el caso de vinculación o sospecha de realización
            de actividades ilícitas o violación de las normas sobre lavado de activos
            y financiación al terrorismo de mi como solicitante, AUTORIZACIÓN
            TRATAMIENTO DE DATOS PERSONALES Y HABEAS DATA AUTORIZO de forma expresa a
            FINCOMERCIO y dentro de lo estipulado en la Ley 1581 de 2012 y 1266 de
            2008, para que reciba, solicite, almacene, consulte, reporte, utilice y
            entregue la información relacionada con mis datos personales para
            únicamente los siguientes efectos: A) Envió de información de datos
            personales con todas las empresas y/o entidades públicas y privadas con
            que la Cooperativa de Ahorro y Crédito tenga convenios vigentes, para
            efectos del desarrollo del objeto y fines sociales que persiguen las
            entidades que pertenecen al sector de la economía solidaria, así mismo
            manifiesto que he sido informado del derecho que me asiste de solicitar
            rectificación y actualización de la información cuando esta no corresponda
            con la realidad, sin que este derecho implique revocatoria alguna a las
            autorizaciones conferidas a la Cooperativa. B) a utilizar por parte de la
            Cooperativa o a través de las empresas con las que suscriba convenios para
            la prestación de servicios y venta de bienes dirigido a los Asociados, la
            información por mi suministrada para el envío de cualquier tipo de
            información como; de servicios, comercial, legal, estatutaria o de
            REPORTES NEGATIVOS ANTE CENTRALES DE INFORMACIÓN FINANCIERA conforme al
            artículo 12 Ley 1266/2008, relacionada con mi comportamiento de pago, a
            través de correos electrónicos, mensajes de texto, por la plataforma
            WhatsApp o por cualquier otro medio de comunicación masiva y tecnológico,
            comunicación telefónica fija o móvil y correspondencia a las direcciones
            registradas en el presente formato y a las que a futuro FINCOMERCIO
            identifique como sitios de localización. C) para que en virtud de las
            obligaciones económicas adquiridas con la cooperativa, en caso de
            presentar mora AUTORIZO a FINCOMERCIO para que entregue los datos
            correspondientes a mi identificación, domicilio, contacto y estado de mis
            obligaciones, con el fin de efectuar las gestiones de cobro jurídico o
            pre-jurídico según correspondan a las empresas de gestión de cobranza
            contratadas para el efecto. D) CERTIFICO que los datos de localización
            aquí suministrados incluyen todos los detalles y no contienen errores.
            Igualmente me comprometo durante la vigencia del vínculo a actualizar la
            información suministrada en la presente solicitud o la que reporta la
            Cooperativa por lo menos una vez al año, no obstante, la actual estará
            vigente hasta tanto no notifique de manera expresa lo contrario, así mismo
            asumo toda la responsabilidad frente a la veracidad y eficiencia de la
            información suministrada y los efectos que se deriven de su falsedad o
            inconsistencia. AUTORIZO de forma libre, autónoma y voluntaria a la
            Cooperativa de Ahorro y crédito FINCOMERCIO para que sin perjuicio de la
            perdida de mi calidad de asociado, cliente, deudor o contratante de los
            servicios de la cooperativa, mantenga dentro de sus bases mis datos
            personales y de contacto con el fin de que pueda contactarme para darme
            información de carácter comercial relativa a la reactivación de los
            servicios de la entidad. En caso de que, en un futuro FINCOMERCIO efectúe
            una venta o cesión a cualquier título de las obligaciones a mi cargo, los
            efectos de la presente autorización se extenderán a éste en los mismos
            términos y condiciones. ACEPTO que FINCOMERCIO no hará devolución de la
            documentación entregada o que contenga cualquier convenio celebrado, la
            cual se archivará o destruirá conforme a las normas y políticas
            aplicables. Asimismo, AUTORIZO de manera permanente e irrevocable y en los
            términos del artículo 8° de la Ley 1527 de 2012, a realizar
            actualizaciones y consultas de mis datos personales contenidos en la base
            de datos de las administradoras de pensiones y de salud, que para el
            efecto autorice o administre el Ministerio de la Protección Social o quien
            haga sus veces. AUTORIZO para consultar en bases de información externas.
            AUTORIZACIÓN Y CONTINUIDAD DE DESCUENTO Entiendo y acepto que, de acuerdo
            con el artículo 144 de la ley 79 de 1988, los descuentos en favor de la
            COOPERATIVA DE AHORRO Y CRÉDITO FINCOMERCIO LTDA tienen prelación sobre
            cualquier otro descuento por obligaciones civiles, salvo las judiciales
            por alimentos. Con mi firma en este documento y en mi calidad de trabajar
            dependiente, pensionado o independiente por prestación de servicios
            AUTORIZO DE MANERA EXPRESA, AMPLIA Y CONTINUA, a mi empleador o pagador
            (definido en el literal b, del artículo 2 de la ley 1527/2012) a descontar
            de mi salario o ingreso mensual la suma que corresponda para que sean
            giradas y entregadas a la Cooperativa De Ahorro y Crédito FINCOMERCIO para
            que sean aplicados a todos mis productos vinculación o afiliación, aporte
            social, ahorros y PAP´s, créditos, convenios y servicios contraídos con
            esta entidad. Así mismo PIGNORÓ O CONSTITUYÓ PRENDA A FAVOR de
            FINCOMERCIO, de conformidad con los parámetros establecidos en la Ley 79
            de 1988, Ley 1527 de 2012 y, aplicando lo establecido en el Código
            Sustantivo del Trabajo (Decreto Ley 2663 de 1950), sobre mis prestaciones
            sociales, salarios, bonificaciones, indemnizaciones, y cualquier otra suma
            o compensación económica a la que tenga derecho por la terminación de mi
            contrato de trabajo, o de prestación de servicios, sea cual sea la causa,
            para que esta Cooperativa aplique a la cancelación del saldo que le esté
            adeudando. Extiendo esta AUTORIZACIÓN a la CONTINUIDAD DE LA AUTORIZACIÓN
            DE DESCUENTO, en los términos del artículo 7° de la Ley 1527 de 2012 y
            demás normas que las actualicen, sustituyan o modifiquen, si llegara a
            cambiar de empresa, empleador o pagador. Independiente a que mi condición
            al momento de mi vinculación sea proveniente de una actividad económica
            como Independiente y no de una relación laboral o contrato de prestación
            de servicios, extiendo los términos de DESCUENTO y CONTINUIDAD DE LA
            AUTORIZACIÓN DE DESCUENTO que trata ese aparte, para que al momento en que
            mi condición cambie a empleado, pensionado o contratista por prestación de
            servicios de alguna entidad pública o privada, FINCOMERCIO dé trámite en
            cualquier tiempo a esta autorización de DESCUENTO y CONTINUIDAD DE LA
            AUTORIZACIÓN DE DESCUENTO. Entiendo de mi obligación de cancelar
            directamente por cualquier medio de recaudo habilitado por FINCOMERCIO los
            valores no descontados por mi empleador o pagador y adeudados por mí,
            mientras comienza a operar esta autorización de descuento y continuidad de
            la autorización de descuento. GARANTÍA AHORROS Entiendo que la Cooperativa
            de Ahorro y Crédito FINCOMERCIO es una entidad sin ánimo de lucro que
            busca el fortalecimiento de sus asociados, con lo cual reconozco que mis
            AHORROS Y APORTES de cualquier naturaleza constituidos en la Cooperativa
            son garantía directa de mis obligaciones contraídas con FINCOMERCIO, en
            caso de mora en el pago habitual de mi(s) cuota (s) comprometida (s).
            AUTORIZACIÓN DÉBITO AUTOMÁTICO AUTORIZO a FINCOMERCIO a debitar de forma
            permanente de la(s) entidad(es) financiera(s) o Cuenta Fincomercio,
            el(los) valor(es) de la(s) cuota(s) autorizada(s) y en la(s) fecha(s)
            establecida(s) en el presente documento. ME COMPROMETO a mantener la
            disponibilidad de fondos en mis cuentas para cubrir el valor reportado por
            FINCOMERCIO el día de cobro. ME COMPROMETO que si por alguna razón la(s)
            Entidad(es) Financiera(s) y/o Fincomercio no realiza(n) el descuento
            del(os) valor(es) de la(s) cuota(s) pactada(s) en la(s) fecha(s)
            reportada(s) por FINCOMERCIO, realizaré dicho(s) pago(s) a través de
            alguno de los canales habilitados por FINCOMERCIO para tal fin. CONVENIO
            VINCULACIÓN Y PRODUCTO POR NÓMINA Entiendo y ACEPTO que si mi vinculación
            se da con apertura de cuenta de nómina me asisten los mismo derechos y
            deberes que se ha relaciona en este documento. Asimismo, ENTIENDO que, una
            vez terminada mi relación con la empresa, la cuenta de nómina cambiará a
            otra cuenta de ahorro vista diferente, manteniendo vigente y activa mi
            vinculación con la cooperativa. Con mi firma en este formulario ACEPTO que
            he sido informado sobre los diferentes conceptos relacionados con las
            formas de pagos de los productos adquiridos con FINCOMERCIO, los cuales
            son: Caja en donde directamente realizaré los pagos en las oficinas de la
            cooperativa, por los canales y entidades financieras autorizadas por
            FINCOMERCIO, descuento de nómina o “libranza, es el descuento directo
            realizado de mi salario por la empresa y lo reporta a FINCOMERCIO, débito
            automático se refiere cuentas externas de otras entidades financieras y
            cuentas internas de FINCOMERCIO. También me comprometo a revisar el
            reglamento de la cuenta de nómina a través de la página web
            www.fincomercio.com.
        </p>

        <br />

        <p class="text-sub-label text-justify">
            AUTORIZO a tomar el producto PLAN GRUPO BASICO FAMILIAR Plan que cubre al
            titular y su grupo familiar de la siguiente forma:• Tarifa Previsión
            Exequial $ 10.600 • Tarifa Seguro de Vida $ 400 • Seguro de vida por
            fallecimiento del titular por $ 5.000.000 • Se realizará factura
            independiente por valor de previsión exequial • Se realizará factura
            independiente por valor de prima de seguro • Dos meses Gratis; todos los
            asociados que ingresen el mes anterior tendrán cobertura gratis de dos
            meses y solo se excluyen los casos que reporte nuestro equipo de
            operaciones de FINCOMERCIO. • Membresía al Club Recodar con todos sus
            beneficios para el titular y grupo familiar • El asociado no interesado en
            continuar con alguno de los productos deberá notificar su cancelación por
            medio de nuestra red de oficinas o línea azul 3078330.ACEPTACION TÁCITA
            Aplica condiciones y restricciones publicados en la web. Ser mayores de
            dieciocho (18) años y menor de 65 años. • Aplica para todos los asociados
            activos Fincomercio incluidos empleados • Cumplir con las condiciones
            indicadas en la mecánica de la activad arriba descritas.• Residir en
            Colombia de manera permanente.• 1 obsequio por asociado nuevo ENTREGA DEL
            BENEFICIO:• Se carga en el estado de cuenta del asociado el 01 del mes
            siguiente a la fecha de vinculación, los dos meses siguientes no tienen
            cobro y a partir del 3 mes se genera cobro de cada producto a los
            asociados. OTRAS CONDICIONES:• Los premios son intransferibles y no son
            redimibles en dinero, en todo ni en parte.• Fincomercio se reserva el
            derecho de establecer otras fechas a la presente actividad.• Fincomercio
            se reserva el derecho de poner término a la presente actividad, o
            descalificar a uno o varios asociados, en caso de existir fraude o intento
            de fraude, dificultades técnicas o cualquier otro factor fuera de control
            que pudieran comprometer la transparencia y seguridad de esta actividad.•
            El asociado acepta y acuerda que cumplirá con todas las reglas de la
            actividad.• La responsabilidad de Fincomercio finaliza con la entrega de
            los dos meses gratis descritos en la parte inicial. Como solicitar el
            Beneficio: Llamar en Bogotá 7484000, 7481616 o a nivel nacional
            018000910571 Línea de servicio Recordar. AUTORIZO de manera permanente,
            irrevocable y continua la consulta y cruces en bases de datos públicas,
            con el fin de dar cumplimiento normativo e instrucciones de los entes de
            control. A continuación, se presentan los términos globales de uso de las
            plataformas BSC Colombia. Con el uso de las plataformas, el usuario acepta
            los términos y condiciones aquí presentados.
        </p>

        <p class="text-sub-label text-justify">
            Si aplica, para que trate, recolecte y entregue la información financiera, 
            demográfica, datos personales, comerciales, privados, fiscales, semiprivados 
            o de cualquier naturaleza del CLIENTE en cumplimiento de regulación de autoridad 
            extranjera, lo mismo que para efectuar las retenciones que igualmente ordenen 
            como consecuencia de los requerimientos u órdenes de tales autoridades, 
            todo lo anterior siempre y cuando le sean aplicables las disposiciones FATCA 
            (ForeignAccountTax ComplianceAct), CRS (Common Reporting Standard) u otros acuerdos 
            de intercambio tributario que sean emitidos por otros Estados. Es necesario notificar 
            a la COOPERATIVA dentro de 30 días de cualquier cambio en circunstancias 
            que afecten al estado de residencia fiscal de sus productos o que hacen 
            que la información suministrada sea errónea, incorrecta o incompleta y 
            proporcionar una nueva Autocertificación de Residencia Fiscal junto con la 
            evidencia documental que sea solicitada por la COOPERATIVA.
        </p>
        <button
        (click)="showTerms.set(false)"
        class="btn-secundary mt-6"
        >
            Aceptar
        </button>
    </app-modal>
}

@if (showAlert()) {
    <div class="flex flex-col justify-center h-screen w-screen">
        <img src="img/arrow.png" alt="" class="h-32 w-auto fixed inset-0 z-50 arrow-animation">
        <app-modal (close)="showAlert.set(false)">
            <div class="space-y-6 text-center">
                <!-- Título más claro -->
                <h2 class="text-xl font-bold text-blue-600">
                    Permiso Denegado
                </h2>

                <!-- Mensaje -->
                <div class="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p class="text-gray-700 text-justify">
                        NO tenemos tu permiso para acceder a la cámara. Por favor, selecciona 'Permitir' en la sección de permisos. Al presionar "Aceptar", iniciemos el reconocimiento facial. Si tienes algún inconveniente o no encuentras este permiso, intenta recargar la página o cambia de navegador.
                    </p>
                </div>

                <!-- Botón -->
                <div class="flex justify-center">
                    <button 
                        (click)="showAlert.set(false)" 
                        class="px-6 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 transition-colors">
                        Aceptar
                    </button>
                </div>
            </div>
        </app-modal>
    </div>
}

@if (recentlyOnboarding()) {
    <app-modal>
        <div class="text-center mx-auto">
            <!-- Logo/Imagen -->
            <div class="flex justify-center mb-5">
            <div class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center p-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </div>
            </div>

            <!-- Título -->
            <h2 class="text-2xl font-bold text-blue-700 mb-4">
            Proceso ya realizado
            </h2>

            <!-- Mensaje -->
            <div class="p-5 bg-blue-50 border border-blue-200 rounded-xl mb-6 shadow-sm">
            <p class="text-gray-700 text-justify leading-relaxed">
                La vinculación ya fue realizada por este canal, te invitamos a visitar www.fincomercio.com, Línea Azul Nacional: (601) 307 8330 o red de oficinas a nivel nacional para conocer todos tus beneficios
            </p>
            </div>
            
            <!-- Botón -->
            <div class="flex justify-center">
            <button 
                onclick="window.location.href='https://www.fincomercio.com/'"
                class="btn-secundary">
                Aceptar
            </button>
            </div>
        </div>
    </app-modal>
}

@if (showError()) {
    <app-error-screen
        [title]="titleError"
        [description]="descriptionError">
    </app-error-screen>
}